module.exports = __webpack_public_path__ + "static/media/forbes-logo.344aa1e5.png";